import React from "react";

import SettingsIcon from "@uui/Settings04";

import FormControlLabel from "@mui/material/FormControlLabel";

import {
  FloatingNavButton,
  FloatingNavIconButton,
} from "@app/analytics/components/reports/FloatingNav";
import MobileDialog from "@app/analytics/MeetingReport/components/MobileDialog";
import { SwitchLabel } from "@app/analytics/MeetingReport/MeetingReportContent/MeetingReportRecapContent/MeetingReportRecapSubnav/RecapSettings/styles";
import useMeetingReportUiStore from "@app/analytics/MeetingReport/stores/ui";
import useVideoStore from "@app/analytics/MeetingReport/stores/video";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import Menu, { MenuBody, MenuHeader } from "@rui/Menu";
import { Row } from "@rui/Stack";
import Switch from "@rui/Switch";
import TooltipIcon from "@rui/TooltipIcon";
import TooltipWrapper from "@rui/TooltipWrapper";

const CoachingSettingsContent = () => {
  const { playbackEnabled, autoPlay, toggleAutoPlay } = useVideoStore(
    (state) => ({
      playbackEnabled: state.playbackEnabled,
      autoPlay: state.autoPlay,
      toggleAutoPlay: state.toggleAutoPlay,
    })
  );

  return (
    <FormControlLabel
      control={<Switch onChange={toggleAutoPlay} />}
      checked={playbackEnabled && autoPlay}
      disabled={!playbackEnabled}
      label={
        <Row variant="left" spacing={1}>
          <SwitchLabel>Auto-play video on click</SwitchLabel>
          <TooltipIcon
            placement="bottom"
            title="Video will automatically play when clicking on notes, transcript turns, and highlights"
          />
        </Row>
      }
    />
  );
};

const CoachingSettingsMenu = () => {
  const { anchorElement, onClick, open, onClose } = useAnchorElement();

  return (
    <>
      <TooltipWrapper placement="bottom" title="Settings">
        <FloatingNavButton Icon={SettingsIcon} onClick={onClick} active={open}>
          Settings
        </FloatingNavButton>
      </TooltipWrapper>
      <Menu
        open={open}
        onClose={onClose}
        anchorEl={anchorElement}
        disablePadding
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuHeader>
          <SettingsIcon />
          <span>Settings</span>
        </MenuHeader>
        <MenuBody spacing={2}>
          <CoachingSettingsContent />
        </MenuBody>
      </Menu>
    </>
  );
};

const CoachingSettingsDialog = () => {
  const setDialog = useMeetingReportUiStore((state) => state.setDialog);

  const handleClick = () => setDialog("coaching_settings");

  return (
    <>
      <FloatingNavIconButton Icon={SettingsIcon} onClick={handleClick}>
        Settings
      </FloatingNavIconButton>
      <MobileDialog id="coaching_settings" title="Settings">
        <CoachingSettingsContent />
      </MobileDialog>
    </>
  );
};

const CoachingSettings = ({ variant }: { variant: "menu" | "dialog" }) => {
  const Component =
    variant === "menu" ? CoachingSettingsMenu : CoachingSettingsDialog;
  return <Component />;
};

export default CoachingSettings;
